import React, { Component } from "react";
import { Form, Input, Select } from "antd";

const { Option } = Select;

const urlSchemaOptions = ["https://", "http://"];

export class UrlInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: this.props.url,
      urlSchema: this.props.urlSchema
    };

    this.handleUrlSchemaChange = this.handleUrlSchemaChange.bind(this);
    this.handleUrlChange = this.handleUrlChange.bind(this);
  }

  handleUrlSchemaChange(urlSchema) {
    this.setState({ urlSchema });
    this.props.sendUrl({
      id: this.props.id,
      url: this.state.url,
      urlSchema: urlSchema
    });
  }

  handleUrlChange(event) {
    this.setState({ url: event.target.value });
    this.props.sendUrl({
      id: this.props.id,
      url: event.target.value,
      urlSchema: this.state.urlSchema
    });
  }

  render() {
    return (
      <Form.Item
        validateStatus={this.props.validationError ? "error" : "validating"}
        help={this.props.validationError && this.props.validationError[0]}>
        <Input
          value={this.state.url}
          placeholder={this.props.placeholder}
          onChange={this.handleUrlChange}
          onKeyPress={e => e.stopPropagation()}
          onKeyDown={e => e.stopPropagation()}
          onKeyUp={e => e.stopPropagation()}
          id={this.props.id}
          addonBefore={
            <Select className="url-schema-select" value={this.state.urlSchema} onChange={this.handleUrlSchemaChange}>
              {urlSchemaOptions.map(opt => (
                <Option key={opt} value={opt}>
                  {opt}
                </Option>
              ))}
            </Select>
          }
        />
      </Form.Item>
    );
  }
}

export default UrlInput;
